export enum WebSocketEventType {
    BULK_UPDATER_UPDATE = 'bulkUpdaterUpdate',
    CLOSING_CALENDAR_UPDATE = 'closingCalendarUpdate',
    DATA_BRIDGE_UPDATE = 'dataBridgeUpdate'
}
